<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">学生设备管理</span>
                <el-row class="grid-content">
                  <el-col class="text-right">
                    <el-input placeholder="搜索" size="medium" clearable suffix-icon="el-icon-search"
                      class="margin-left-10 search-InputBox" v-model="searchCondition.KeyWord" @change="onSearchConditionChanged"
                      @keyup.enter.native="onSearchConditionChanged">
                    </el-input>
                  </el-col>
                </el-row>
                <el-row class="grid-content">
                  <el-table v-loading="loading" :data="studentList" :header-row-class-name="'el-table-header'" row-key="Id"
                    default-expand-all :tree-props="{children: 'Devices'}">
                    <el-table-column prop="Name" label="学生手机号/设备ID"></el-table-column>
                    <el-table-column label="设备数量" width="160px">
                      <template slot-scope="scope">
                        {{ scope.row.DeviceId ? "" : (scope.row.Devices || []).length}}
                      </template>
                    </el-table-column>
                    <el-table-column label="解绑" width="160px">
                      <template slot-scope="scope">
                        <el-button size="medium" :loading="loading" v-if="scope.row.DeviceId"
                          v-on:click="unbindDevice(scope.row.Id)" type="primary">解绑设备</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="searchCondition.PageNumber" :page-sizes="[20, 50, 100]" :page-size="searchCondition.PageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="recordTotal">
                  </el-pagination>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.grid-content {
  /deep/ .el-table .cell {
    white-space: pre-line;
  }
}

.search-InputBox {
  width: 200px;
}

.cs-contentContainer {
  .grid-content {
    margin-bottom: 10px;

    .cs-schedule-buttonContainer {
      text-align: right;
    }
  }
}
</style>

<script>
import navigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import {
  removeDevice,
  getAllStudentDevices,
} from "../../service/studentDevice.service";

export default {
  data() {
    return {
      searchCondition: {
        KeyWord: null,
        PageNumber: 1,
        PageSize: 20,
      },
      loading: false,
      studentList: [],
      recordTotal: 0,
    };
  },
  components: {
    navigator,
    pagination,
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async onSearchConditionChanged() {
      await this.loadData();
    },
    async handleSizeChange(pageSize) {
      this.searchCondition.PageSize = pageSize;
      await this.loadData();
    },
    async handleCurrentChange(currentPage) {
      this.searchCondition.PageNumber = currentPage;
      await this.loadData();
    },
    async unbindDevice(deviceIntegerId) {
      try {
        await this.$confirm("是否要删除此设备?", "确认信息", {
          distinguishCancelAndClose: true,
          type: "warning",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        });

        this.loading = true;

        await removeDevice(deviceIntegerId);

        await this.loadData();
      } catch (ex) {
        //do nothing..
      }

      this.loading = false;
    },
    async loadData() {
      this.loading = true;
      const result = await getAllStudentDevices(this.searchCondition);
      if (result.success) {
        this.studentList = result.data.Results;
        this.recordTotal = result.data.RecordCount;
      } else {
        this.$message.error("加载失败: " + result.message);
      }
      this.loading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/page/admin/studentDevice.vue